import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import { InsuranceBox } from "./insurance";

import features1 from "../../static/images/landingpage/features/dich_vu_thue_xe_tu_lai_hanoi.svg";
import features2 from "../../static/images/landingpage/features/cho_thue_xe_tu_lai_tphcm.svg";
import features3 from "../../static/images/landingpage/features/cho_thue_xe_tu_lai_hanoi.svg";
import features4 from "../../static/images/landingpage/features/thue_xe_tu_lai_gia_re_hcm.svg";
import features5 from "../../static/images/landingpage/features/thue_xe_tu_lai_gia_re_hanoi.svg";
import features6 from "../../static/images/landingpage/features/thue_xe_co_tai_xe.svg";

const FEATURES = [
	{
		id: 6,
		img: features6,
		alt: "thue_xe_co_tai_xe",
		title: "Lái xe an toàn cùng Mioto",
		sub: "Chuyến đi trên Mioto được bảo vệ với Gói bảo hiểm thuê xe tự lái từ MIC&nbsp;&&nbsp;VNI.<br />Khách thuê sẽ chỉ bồi thường tối đa 2,000,000VNĐ trong trường hợp có sự cố ngoài ý muốn.",
	},
	{
		id: 1,
		img: features1,
		alt: "dich_vu_thue_xe_tu_lai_hanoi",
		title: "An tâm đặt xe",
		sub: "Không tính phí huỷ chuyến trong vòng 1h sau khi đặt cọc. Hoàn cọc và bồi thường 100% nếu chủ xe huỷ chuyến trong vòng 7 ngày trước chuyến&nbsp;đi.",
	},
	{
		id: 2,
		img: features2,
		alt: "cho_thue_xe_tu_lai_tphcm",
		title: "Thủ tục đơn giản",
		sub: "Chỉ cần có CCCD gắn chip (Hoặc Passport) & Giấy phép lái xe là bạn đã đủ điều kiện thuê xe trên&nbsp;Mioto.",
	},
	{
		id: 3,
		img: features3,
		alt: "cho_thue_xe_tu_lai_hanoi",
		title: "Thanh toán dễ dàng",
		sub: "Đa dạng hình thức thanh toán: ATM, thẻ Visa & Ví điện tử (Momo, VnPay, ZaloPay).",
	},
	{
		id: 4,
		img: features4,
		alt: "thue_xe_tu_lai_gia_re_hcm",
		title: "Giao xe tận nơi",
		sub: "Bạn có thể lựa chọn giao xe tận nhà/sân bay... Phí tiết kiệm chỉ từ 15k/km.",
	},
	{
		id: 5,
		img: features5,
		alt: "thue_xe_tu_lai_gia_re_hanoi",
		title: "Dòng xe đa dạng",
		sub: "Hơn 100 dòng xe cho bạn tuỳ ý lựa chọn: Mini, Sedan, CUV, SUV, MPV, Bán&nbsp;tải.",
	},
];

const FeatureItem = ({ id, img, alt, title, sub, func }) => {
	return (
		<div className={`features-item ${id === 6 ? "pointer" : ""}`} onClick={id === 6 ? func : null}>
			<div className="features-item__img">
				<img loading="lazy" src={img} alt={alt} />
			</div>
			<h5>{title}</h5>
			<p dangerouslySetInnerHTML={{ __html: sub }} />
		</div>
	);
};

const Features = () => {
	const [showInsBox, setShowInsBox] = useState(false);

	const toggleInsBox = () => {
		setShowInsBox(!showInsBox);
	};

	return (
		<div className="features-section space sec">
			<div className="m-container">
				<h2>Ưu Điểm Của&nbsp;Mioto</h2>
				<h5 className="title">Những tính năng giúp bạn dễ dàng hơn khi thuê xe trên&nbsp;Mioto.</h5>
				<div className="features-container">
					{FEATURES.map((feature) => (
						<FeatureItem
							key={feature.id}
							id={feature.id}
							img={feature.img}
							alt={feature.alt}
							title={feature.title}
							sub={feature.sub}
							func={toggleInsBox}
						/>
					))}
				</div>
				<div className="features-swiper-container">
					<Swiper
						className={`swiper-features`}
						spaceBetween={10}
						slidesPerView={1}
						modules={[Pagination]}
						pagination={{
							el: ".pagi-features",
							clickable: true,
							dynamicBullets: true,
						}}>
						{FEATURES.map((feature) => (
							<SwiperSlide key={feature.id}>
								<FeatureItem
									id={feature.id}
									img={feature.img}
									alt={feature.alt}
									title={feature.title}
									sub={feature.sub}
									func={toggleInsBox}
								/>
							</SwiperSlide>
						))}
						<div className="swiper-pagination pagi-features"></div>
					</Swiper>
				</div>
			</div>
			<InsuranceBox show={showInsBox} onHide={toggleInsBox} />
		</div>
	);
};

export default Features;
